// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"490":"e3fe17091387357c","537":"571b405cad91ecdc"}[chunkId] + ".js";
};